import getAll from './getAll';
export default {
  getAll,
};
